var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2806 4.2805C14.6781 3.88305 15.3225 3.88306 15.7199 4.28053C16.1174 4.67798 16.1173 5.32236 15.7199 5.7198L15.0837 6.35602C14.2966 6.34714 13.6533 5.70384 13.6443 4.91677L14.2806 4.2805ZM12.4183 6.14281L6.26405 12.297C5.45728 13.1037 5.1567 13.4132 4.95055 13.7772C4.74622 14.1381 4.63569 14.5509 4.36429 15.6361C5.44943 15.3647 5.86224 15.2541 6.22312 15.0498C6.58721 14.8437 6.89661 14.5431 7.70337 13.7363L13.8576 7.5821C13.2257 7.28726 12.7131 6.77475 12.4183 6.14281ZM16.7806 3.21989C15.7974 2.23662 14.2032 2.2366 13.22 3.21984L5.2034 11.2363L5.12985 11.3098C4.42149 12.0179 3.96401 12.4752 3.64526 13.0382C3.3265 13.6012 3.16974 14.2287 2.92701 15.2005L2.90181 15.3013L2.60591 16.4849C2.54201 16.7405 2.6169 17.0109 2.80318 17.1972C2.98947 17.3835 3.25983 17.4584 3.51541 17.3945L4.69904 17.0985L4.79993 17.0733C5.77163 16.8306 6.39919 16.6739 6.96217 16.3551C7.52514 16.0364 7.98244 15.5789 8.69051 14.8705L8.76403 14.797L16.7806 6.78046C17.7638 5.79724 17.7638 4.20313 16.7806 3.21989Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/EditWhite.27246b8de525aa836b647428b6ccc303.svg";
export { ForwardRef as ReactComponent };